import React from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        keyIssueCategories: state.keyIssueCategories
    }
}

const KeyIssueChip = ({ classes, keyIssue, keyIssueCategories, onClickEvent, showKeyIssues }) => {
    const color = keyIssueCategories?.find(c => c.name === keyIssue?.category)?.color

    return (
        <button
            tabIndex={showKeyIssues ? -1 : 1}
            className={`key-issue-chip ${color} ${classes}`}
            onClick={onClickEvent}
            data-id={`${keyIssue?.title}`}>
            <div className="chip" style={{ backgroundImage: `url(${keyIssue.thumbnail.url})` }} />
            <div className={`label ${color}-bg`} >
                {keyIssue.title}
            </div>
        </button>
    )
}

export default connect(mapStateToProps)(KeyIssueChip)
